import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Badge from 'components/common/Badge/Badge'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import { MobileButtonWithAddToQuoteHandler, ButtonWithAddToQuoteHandler } from 'components/OneColumnSearchResultPage/components/AddToQuoteButton'
import QuantityPrice from 'components/OneColumnSearchResultPage/components/QuantityPrice'
import InlineProductHeader from 'components/OneColumnSearchResultPage/BOTRecommendedSearchResult/components/InlineProductHeader'
import {
  Block,
  Cell,
  RightUpdatingBlock,
  PriceLink,
  CustomButton,
  ButtonColumns
} from 'components/OneColumnSearchResultPage/components/ProductBlock/styles'

const RecommendedProduct = ({
  bvId,
  brandName,
  countFront,
  compatibilityState,
  disableAddToQuote,
  avgRating,
  brandLogoUrl,
  expanderMenu,
  productDisplayName,
  title,
  quantityInputId,
  price,
  salePrice,
  imagePath,
  warranty,
  compareDisabled,
  handleCompareTrayAdd,
  skuId,
  handleFindLowerPriceClick,
  myStore,
  showStoreLocatorModal,
  sizeFront,
  sizeRear,
  specifications,
  promotions,
  promotionsPreviewItems,
  promotionsRestItems,
  tooltip,
  vehicleName,
  reviewsLink,
  tireDetailUrl,
  handleProductClick,
  handleFrontQuantityChange,
  isAllCompatible,
  isHorizontal,
  warrantyBadges,
  hasMapPrice,
  seePriceIncartMessage,
  zeroPriceItemMessage,
  countRear,
  isOeItem,
  isEvItem,
  itemEVType,
  isPilotStore,
  inventoryStatuses,
  availability
}) =>
  <React.Fragment>
    <Badge
      empty
      productBadge
      category={ title }
      tooltip={ tooltip } />
    <Product data-at-serp-tire data-tire-gbb>
      <Block>
        <CustomCell>
          <InlineProductHeader
            availability={ availability }
            storeNumber={ myStore.storeNumber }
            skuId={ skuId }
            bvId={ bvId }
            brandName={ brandName }
            compatibilityState={ compatibilityState }
            inventoryStatuses={ inventoryStatuses }
            isAllCompatible={ isAllCompatible }
            isHorizontal={ isHorizontal }
            isPilotStore={ isPilotStore }
            srcTire={ imagePath }
            srcLogo={ brandLogoUrl }
            reviewsLink={ reviewsLink }
            tireDetailUrl={ tireDetailUrl }
            title={ productDisplayName }
            sizeFront={ sizeFront }
            ratingCount={ avgRating }
            vehicleName={ vehicleName }
            warranty={ warranty }
            warrantyBadges={ warrantyBadges }
            specifications={ specifications }
            promotions={ promotions }
            promotionsPreviewItems={ promotionsPreviewItems }
            promotionsRestItems={ promotionsRestItems }
            handleProductClick={ handleProductClick }
            expanderMenu={ expanderMenu }
            countFront={ countFront }
            countRear={ countRear }
            isOeItem={ isOeItem }
            itemEVType={ itemEVType }
            isEvItem={ isEvItem } />
        </CustomCell>
        <RightUpdatingBlock name={ ADDING_TO_SHOPPING_QUOTE } value={ skuId } >
          <QuantityPrice
            quantityInputId={ quantityInputId }
            dataAttributes={{ 'data-at-serp-gbb-price': true }}
            priceTitle={ sizeRear ? 'Front' : '' }
            defaultValue={ countFront }
            showStoreLocatorModal={ showStoreLocatorModal }
            handleQuantityChange={ handleFrontQuantityChange }
            hasMapPrice={ hasMapPrice }
            seePriceIncartMessage={ seePriceIncartMessage }
            zeroPriceItemMessage={ zeroPriceItemMessage }
            priceOld={ price }
            priceSale={ salePrice }
            myStore={ myStore }
            count={ countFront } />
          <Media.Mobile>
            <ButtonColumns width="50% 50%">
              <CustomButton
                data-at-compare-button
                full
                secondary
                disabled={ compareDisabled }
                onClick={ handleCompareTrayAdd }>
                + Compare
              </CustomButton>
              <MobileButtonWithAddToQuoteHandler
                full
                disabled={ disableAddToQuote }
                productInfo={{ skuId, quantity: countFront, label: title, oeFlag: isOeItem, evFlag: isEvItem }} />
            </ButtonColumns>
          </Media.Mobile>
          <Media.Desktop>
            <ButtonWithAddToQuoteHandler
              productInfo={{ skuId, quantity: countFront, label: title, oeFlag: isOeItem, evFlag: isEvItem }}
              disabled={ disableAddToQuote } />
            <CustomButton
              data-at-compare-button
              stacked
              secondary
              full
              narrow
              disabled={ compareDisabled }
              onClick={ handleCompareTrayAdd }>
              + Compare
            </CustomButton>
          </Media.Desktop>
          {
            myStore &&
            <PriceLink bolder prevent handler={ handleFindLowerPriceClick }>
              Found a lower price? Let us know.
            </PriceLink>
          }
        </RightUpdatingBlock>

      </Block>
    </Product>
  </React.Fragment>

RecommendedProduct.propTypes = {
  availability: PropTypes.shape(),
  avgRating: PropTypes.number,
  brandLogoUrl: PropTypes.string,
  brandName: PropTypes.string,
  bvId: PropTypes.string,
  compareDisabled: PropTypes.bool,
  compatibilityState: PropTypes.string,
  countFront: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  countRear: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  disableAddToQuote: PropTypes.bool,
  expanderMenu: PropTypes.arrayOf(PropTypes.shape()),
  handleCompareTrayAdd: PropTypes.func,
  handleFindLowerPriceClick: PropTypes.func,
  handleFrontQuantityChange: PropTypes.func,
  handleProductClick: PropTypes.func,
  hasMapPrice: PropTypes.bool,
  imagePath: PropTypes.string,
  inventoryStatuses: PropTypes.arrayOf(PropTypes.shape()),
  isAllCompatible: PropTypes.bool,
  isEvItem: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  isOeItem: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  itemEVType: PropTypes.string,
  myStore: PropTypes.shape(),
  price: PropTypes.number,
  productDisplayName: PropTypes.string,
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  promotionsPreviewItems: PropTypes.arrayOf(PropTypes.shape()),
  promotionsRestItems: PropTypes.arrayOf(PropTypes.shape()),
  quantityInputId: PropTypes.string,
  reviewsLink: PropTypes.string,
  salePrice: PropTypes.number,
  seePriceIncartMessage: PropTypes.string,
  showStoreLocatorModal: PropTypes.func,
  sizeFront: PropTypes.string,
  sizeRear: PropTypes.string,
  skuId: PropTypes.string,
  specifications: PropTypes.arrayOf(PropTypes.shape()),
  tireDetailUrl: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  vehicleName: PropTypes.string,
  warranty: PropTypes.string,
  warrantyBadges: PropTypes.arrayOf(PropTypes.shape()),
  zeroPriceItemMessage: PropTypes.string
}

export default RecommendedProduct

const Product = styled.div`
  background-color: ${Theme.colors.white};
  box-shadow: 1px 1px 4px ${Theme.colors.transparent_overlay_shadow};
  margin-bottom: 30px;
`

const CustomCell = styled(Cell)`
  padding: 37px 20px 0;
`
